export const constants = {
  GET_LINE_SERVICES: 'GET_LINE_SERVICES',
  GET_LINE_SERVICES_SUCCESS: 'GET_LINE_SERVICES_SUCCESS',
  GET_LINE_SERVICES_ERROR: 'GET_LINE_SERVICES_ERROR',
  GET_LINE_SERVICE_DETAIL: 'GET_LINE_SERVICE_DETAIL',
  GET_LINE_SERVICE_DETAIL_SUCCESS: 'GET_LINE_SERVICE_DETAIL_SUCCESS',
  GET_LINE_SERVICE_DETAIL_ERROR: 'GET_LINE_SERVICE_DETAIL_ERROR',
};

export const services = {
  getLineServices: (lineUuid) => ({
    route: `/api/v2/lines/${lineUuid}/services`,
    method: 'get',
  }),
  getLineServiceDetail: (lineUuid, serviceSlug) => ({
    route: `/api/v2/lines/${lineUuid}/services/${serviceSlug}`,
    method: 'get',
  }),
};
